<InactivityModal />

<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <div class="col h-100 overflow-auto mt-2">
        <div class="visitor-card shadow border-primary">
          <div class="container-fluid px-0 pb-4">
            <div class="card-body bg-white pt-2">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

              <div class="d-flex justify-content-between align-items-center sticky-top mb-4">
                <div></div>
              </div>

              <div v-if="is_loading" class="text-center py-5 w-100">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 mb-0 text-muted text-xxs">Loading campaigns...</p>
              </div>

              <div v-else>
                <div class="d-flex justify-content-end mb-3">
                  <button type="button" class="btn btn-primary text-xxs rounded-3 shadow-sm px-2 py-1"
                    @click="go_to_create_campaign_page()">
                    Create Campaign
                  </button>
                </div>

                <div class="dashboard-stat-scroll">
                  <div class="row g-2 mb-3">
                    <div
                      v-for="card in donation_dashboard_cards"
                      :key="card.label"
                      class="col-6 col-md-4 col-xl"
                    >
                      <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                        <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                          <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                            <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                            <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                          </div>
                          <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                            <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="campaigns.length" class="table-responsive">
                <table id="campaignDashboardTable" class="table align-middle table-striped table-borderless w-100">
                  <thead class="btn-primary text-white">
                    <tr>
                      <th class="text-xxs fw-light text-center">No.</th>
                      <th class="text-xxs fw-light">Campaign Name</th>
                      <th class="text-xxs fw-light text-center">Category</th>
                      <th class="text-xxs fw-light text-center">Status</th>
                      <th class="text-xxs fw-light text-center">Raised</th>
                      <th class="text-xxs fw-light text-center">Goal</th>
                      <th class="text-xxs fw-light text-center">Donors</th>
                      <th class="text-xxs fw-light text-center">% Funded</th>
                      <th class="text-xxs fw-light text-center">Start Date</th>
                      <th class="text-xxs fw-light text-center">End Date</th>
                      <th class="text-xxs fw-light text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(campaign, index) in campaigns" :key="campaign.id" class="border-bottom text-xxs">
                      <td class="text-center">
                          {{ index + 1 }}
                      </td>
                      <td>
                        <div>{{ campaign.name }}</div>
                      </td>
                      <td class="text-center">
                        <span class="text-xxs">
                          {{ campaign?.category?.name || "Uncategorized" }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge rounded-pill text-capitalize text-xxs fw-normal px-3 py-2"
                          :class="{
                            'bg-success-subtle text-success': String(campaign.status || '').toLowerCase() === 'active',
                            'bg-warning-subtle text-warning': String(campaign.status || '').toLowerCase() === 'paused',
                            'bg-info-subtle text-info': String(campaign.status || '').toLowerCase() === 'completed',
                            'bg-secondary-subtle text-secondary': !['active', 'paused', 'completed'].includes(String(campaign.status || '').toLowerCase()),
                          }"
                        >
                          {{ campaign.status || "draft" }}
                        </span>
                      </td>
                      <td class="text-center">{{ format_currency(get_campaign_raised_amount(campaign)) }}</td>
                      <td class="text-center">{{ format_currency(campaign.goal_amount) }}</td>
                      <td class="text-center">{{ get_campaign_donor_count(campaign) }}</td>
                      <td class="text-center">{{ get_progress(campaign) }}%</td>
                      <td class="text-center">{{ format_date(campaign.start_date) }}</td>
                      <td class="text-center">{{ format_date(campaign.end_date) }}</td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-light btn-sm rounded-3 text-primary border text-xxs px-3"
                          @click="open_campaign(campaign)"
                        >
                          Open
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>

                <div v-else class="text-center py-5 border rounded-3 bg-white">
                  <i class="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                  <div class="mb-1 text-xxs">No campaigns yet</div>
                  <div class="small text-muted text-xxs">Campaigns will appear here once available.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
